import useAPI from '@/hooks/useAPI';
import InsuranceRepository from '@/repositories/InsuranceRepository';

const useInsuranceRelationships = (enabled = true) => {
  const insuranceRepository = InsuranceRepository();

  return useAPI({
    queryKey: ['getInsuranceRelationships'],
    queryFn: async () => {
      return await insuranceRepository.getInsuranceRelationships();
    },
    enabled
  });
};

export default useInsuranceRelationships;
